import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SavedQueryType } from '../../../../types';

export type FavoriteItemPropsType = {
  savedQuery: SavedQueryType;
  onSelect: (favoriteId: string) => void;
  onDelete: (favoriteId: string) => void;
};

export const FavoriteItem: React.FC<FavoriteItemPropsType> = ({
  savedQuery,
  onSelect,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Menu.Item
      onClick={() => onSelect(savedQuery.id)}
      rightSection={
        <ActionIcon
          aria-label={t('QUERY_BUILDER.FAVORITES.DELETE.LABEL', {
            name: savedQuery.name,
          })}
          color="red"
          variant="subtle"
          onClick={(event) => {
            event.stopPropagation();
            onDelete(savedQuery.id);
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </ActionIcon>
      }
    >
      {savedQuery.name}
    </Menu.Item>
  );
};
